<zah-upsert-client [zones]="zones$ | async"
                   [diensten]="diensten$ | async"
                   okLabel="Voeg toe"
                   (cancelClicked)="onCancelClicked()"
                   (okClicked)="onAddClicked($event)">
</zah-upsert-client>
